export default {
  data: () => ({
    accountNumberRules: [
      v => !!v || 'Account number is required',
      v => (v || '').length <= 50 || 'Account number can not exceed 50 digits',
    ],
    emailRules: [v => !!v || 'E-mail is required', v => !v || /.+@.+\..+/.test(v) || 'E-mail must be valid'],
    optionalEmailRules: [v => !v || /.+@.+\..+/.test(v) || 'E-mail must be valid'],
    nameRules: [v => !!v || 'Full name is required'],

    // Updated phoneRules to allow various international formats
    phoneRules: [
      v => !!v || 'Phone number is required',
      v => !v || /^(\+|00|\d{1,3})/.test(v) || 'Phone number must be valid',
      v => !v || /^[\d+\s\-()]+$/.test(v) || 'Phone number must contain valid characters',
      v => !v || (v.replace(/[\s\-()+]/g, '').length >= 7 && v.replace(/[\s\-()+]/g, '').length <= 15) || 'Phone number must be 7-15 digits',
    ],

    meterPhoneRules: [
      v => !v || /^(\+|00|254)/.test(v) || 'Phone number must start with 254 or be international (+XX or 00XX)',
      v => !v || /^[\d+\s\-()]+$/.test(v) || 'Phone number must contain valid characters',
      v => !v || (v.replace(/[\s\-()+]/g, '').length <= 20) || 'Phone number can not exceed 20 digits',
    ],

    numberRules: [v => !!v || 'required', v => v > 0 || 'The value must be greater than 0'],
    optionalNumberRules: [v => !v || v > 0 || 'The value must be greater than 0'],
    numberRulesAllowZero: [v => v >= 0 || 'The value must be greater than or equal to 0'],

    optionalPhoneRules: [
      v => !v || /^(\+|00|\d{1,3})/.test(v) || 'Phone number must be valid',
      v => !v || /^[\d+\s\-()]+$/.test(v) || 'Phone number must contain valid characters',
      v => !v || (v.replace(/[\s\-()+]/g, '').length <= 15) || 'Phone number can not exceed 15 digits',
    ],

    meterReadingRules: [
      v => !!v || 'Meter reading is required',
      v => /^\d{0,6}(\.\d{0,3}){0,1}$/.test(v) || 'Please input a valid reading',
    ],
    meterReadingDateRules: [
      v => !!v || 'required',
      v => v > 0 || 'The value must be greater than 0',
      v => v <= 28 || 'The value must be less than 28',
    ],
    meterNumberRules: [
      v => !!v || 'Meter number is required',
    ],
    requiredRules: [v => !!v || 'required'],
  }),
}
